import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { EmployerContact } from '../../../../models/employers/dto/employer-contact';

@Component({
  selector: 'app-employer-contact-card',
  templateUrl: './employer-contact-card.component.html',
  styleUrls: ['./employer-contact-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployerContactCardComponent {
  @Input() contact!: EmployerContact;
  @Input() isCollapsed = true;
  @Output() toggle = new EventEmitter<void>();
}
